import { yellow, red, green, common } from '@mui/material/colors';

enum NoteColor {
  YELLOW = 'yellow',
  RED = 'red',
  GREEN = 'green',
  WHITE = 'white'
}

/**
 * Type to represent the color weight (intensity).
 */
type ColorWeight = 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;

/**
 * Get the color key based on the value provided.
 *
 * @param {unknown} value - The value to check.
 * @returns {NoteColor} The color key.
 */
const getColorKey = (value: unknown) => {
  if (Object.values(NoteColor).includes(value as NoteColor)) {
    return value as NoteColor;
  }
  return NoteColor.YELLOW;
};

/**
 * Convert a NoteColor and weight to a hex color code.
 *
 * @param {NoteColor} color - The color key.
 * @param {ColorWeight} [weight=500] - The color weight.
 * @returns {string} The hex color code.
 */
const colorToHex = (color: NoteColor, weight: ColorWeight = 500): string => {
  switch (color) {
    case NoteColor.YELLOW:
      return yellow[weight];
    case NoteColor.RED:
      return red[weight];
    case NoteColor.GREEN:
      return green[weight];
    case NoteColor.WHITE:
      return common.white;
    default:
      return yellow[weight]; // Default to yellow
  }
};

/**
 * Get the color based on the provided value and weight.
 *
 * @param {unknown} value - The value to get the color for.
 * @param {ColorWeight} [weight=500] - The color weight.
 * @returns {string} The hex color code.
 */
const getColor = (value: unknown, weight: ColorWeight = 500) => colorToHex(getColorKey(value), weight);

export const NoteHelper = {
  getColorKey,
  colorToHex,
  getColor
};
